import React from "react";
import useSalesReceiptStore from "../store";
import { Table } from "react-bootstrap";
import { ExclamationCircleFill } from "react-bootstrap-icons";
import { useParams, useSearchParams } from "react-router-dom";
import useAppStore from "../../../store/global";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { queryClient } from "../../../App";
import { findTitleById } from "../../Classification/utils";
export default function LaborTable() {
  const [searchParams] = useSearchParams();
  const date = searchParams.get("date");
  const { laborData, hasUncategorizedLabor } = useSalesReceiptStore();
  const data = queryClient.getQueryData(["allCategories"]);
  const { setDateRange } = useAppStore();

  const { id } = useParams();
  if (laborData.length === 0) {
    return null;
  }
  const handleSeeReport = () => {
    let updatedDate = new Date(date);
    updatedDate.setUTCHours(18, 30, 0, 0);
    updatedDate.setDate(updatedDate.getDate() - 1);
    const updatedDateRange = [
      {
        startDate: updatedDate.toISOString(),
        endDate: updatedDate.toISOString(),
        key: "selection",
      },
    ];
    setDateRange(updatedDateRange);
    window.open(
      `/restaurants/${id}/labour-reports/`,
      "_blank",
      "noopener,noreferrer"
    );
  };
  const formatLabor = (labor_category_name) => {
    let appendMinus = false;
    if (labor_category_name && labor_category_name?.startsWith("neg-")) {
      labor_category_name = labor_category_name.replace("neg-", "");
      appendMinus = true;
    }
    if (data === undefined) { return labor_category_name; }
    labor_category_name = findTitleById(
      data?.categories?.filter((item) => item.type === "Labor"),
      labor_category_name
    );
    if (labor_category_name === "Back of the House" && appendMinus===false) {
      return "ACC BOH Staff Wages (+)";
    } else if (labor_category_name === "Back of the House" && appendMinus===true) {
      return "BOH Wages (-)";
    }
    if (labor_category_name === "Front of the House" && appendMinus===false) {
      return "ACC FOH Staff Wages (+)";
    } else if (labor_category_name === "Front of the House" && appendMinus===true) {
      return "FOH Wages (-)";
    }
    if (
     ( labor_category_name === "Management" ||
      labor_category_name === "Support Staff") && appendMinus===false
    ) {
      return "ACC MGMT Wages (+)";
    } else if (
     ( labor_category_name === "Management" ||
      labor_category_name === "Support Staff") && appendMinus===true
    ) {
      return "MGMT Wages (-)";
    }
    if (labor_category_name === "No Employee Type Assigned" && appendMinus===false) {
      return "No Role (+)";
    } else if (labor_category_name === "neg-No Employee Type Assigned" && appendMinus===true) {
      return "No Role (-)";
    }
  };

  console.log("the labor datay here is ", laborData);
  return (
    <div className="mx-3 my-3 border-white rounded shadow-sm p-3">
      <div className="d-flex mb-0 justify-content-between">
        <h4>Labor Data</h4>
        <OverlayTrigger
          key={"top"}
          placement={"top"}
          overlay={
            <Tooltip id={`tooltip-discount`}>
              {hasUncategorizedLabor
                ? "Uncategorized labor entries found"
                : "View Report"}
            </Tooltip>
          }
        >
          <p
            className={
              "fs-32 mx-3 my-1" +
              (hasUncategorizedLabor ? " text-danger" : "text-muted")
            }
            onClick={handleSeeReport}
            style={{ cursor: "pointer" }}
          >
            <ExclamationCircleFill className="mx-2" />
            See Report
          </p>
        </OverlayTrigger>
      </div>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Category</th>
            <th>Total Amount</th>
          </tr>
        </thead>
        <tbody>
          {laborData
            .map((item, index) => (
              <tr key={index}>
                <td
                  style={
                    item.category === "Total" ? { fontWeight: "bold" } : {}
                  }
                >
                  {formatLabor(item.labor_category)}
                </td>
                <td
                  style={
                    item.Category === "Total" ? { fontWeight: "bold" } : {}
                  }
                >
                  {item["total_employee_amount"] !== ""
                    ? item["total_employee_amount"].toFixed(2)
                    : "N/A"}
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  );
}
